import React,{useState} from "react";
import { Box, Button, Stack, IconButton } from "@mui/material";
// mui icons
import {
	HelpOutlineOutlined,
} from "@mui/icons-material";

import FormSection from "../../dynamic-form/FormSection";
import FormField from "../../dynamic-form/FormField";
import CustomDivider from "../../custom-divider";
import RequiredError from "../../required-error";
import Body2 from "../../typography/body-02";

import { generateFieldId } from "../../../utils/formId";
import {
  QUICK_PRICER_FORM_CONFIG,
  isBuydownEligible,
} from "../quickPricer.form.config";
import RenderField from "./RenderField";
import styles from "../index.module.scss";
import CreditScoreHelpTextModal from "../../modal/credit-score-help-text-modal";

const QuickPricerForm = ({
  sections,
  formState,
  setFormState,
  errors,
  setErrors,
  submitted,
  handleSubmit,
  isCorrOrNdcChannel,
}) => {
  const { formName } = QUICK_PRICER_FORM_CONFIG;

  const updateField = (name) => (e) => {
    const value = e?.target?.value ?? e;
    setFormState((prev) => {
      const nextState = { ...prev, [name]: value };

      if (
        (name === "loanPurpose" || name === "numberofUnits") &&
        !isBuydownEligible(nextState)
      ) {
        return {
          ...nextState,
          buydown: "None",
          buydownContributorType: "NotApplicable",
        };
      }

      if (name === "buydown") {
        if (
          value === "None" ||
          prev.buydown === "None" ||
          prev.buydownContributorType === "NotApplicable"
        ) {
          return {
            ...nextState,
            buydownContributorType:
              value === "None" ? "NotApplicable" : "",
          };
        }
      }

      return nextState;
    });
  };

  const [creditScoreHelpTextOpen, setCreditScoreHelpTextOpen] = useState(false);

  const handleOpenCreditScoreHelpText = () => {
    setCreditScoreHelpTextOpen(true);
  };

  const handleCloseCreditScoreHelpText = () => {
    setCreditScoreHelpTextOpen(false);
  };

const renderLabel = (field) => {
  const isRequired =
    typeof field.required === "function"
      ? field.required(formState)
      : field.required;

  return (
    <>
      {field.label}
      {isRequired && (
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
      )}
      {field.name === "qualifyingCreditScore" &&
      <IconButton
        className={styles.helperIconBtn}
        onClick={() => {
          handleOpenCreditScoreHelpText();
        }}
      >
      <HelpOutlineOutlined className={styles.helperIcon} />
      </IconButton>}
    </>
  );
};

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      className={styles.stackContainer}
    >
      {sections.map((section, sectionIndex) => (
        <React.Fragment key={section.name}>
          <FormSection
            title={section.title}
            titleClass={styles.title}
          >
            {section.fields
              .filter((field) =>
                field.visibleIf ? field.visibleIf(formState) : true
              )
              // Hidden, not cleared: formState.lenderPaidvsBorrowerPaid still
              // carries the "YesLenderPaid" default set in index.jsx, so the
              // API payload is unaffected by this field being hidden here.
              .filter(
                (field) =>
                  !(field.name === "lenderPaidvsBorrowerPaid" && isCorrOrNdcChannel)
              )
              .map((field) => {
                return field.descriptionSection ? (
                  <Box key={field.name} sx={{ width: "100%", mb: 2 }}>
                    <Body2
                      text={field.descriptionSection}
                      style={{ display: "block", width: "100%" }}
                    />
                  </Box>
                ) : (
                  <FormField
                    key={field.name}
                    label={renderLabel(field)}
                    htmlFor={generateFieldId(
                      formName,
                      section.name,
                      field.name,
                      field.component
                    )}
                    isFullWidth={field.isFullWidth}
                  >
                    <RenderField
                      field={field}
                      fieldId={generateFieldId(
                        formName,
                        section.name,
                        field.name,
                        field.component
                      )}
                      formState={formState}
                      updateField={updateField}
                      errors={errors}
                      setErrors={setErrors}
                      submitted={submitted}
                    />
                  </FormField>
                );
              })}
          </FormSection>

          {sectionIndex < sections.length - 1 && (
            <CustomDivider extraClass={styles.divider} />
          )}
        </React.Fragment>
      ))}

      {Object.keys(errors).length > 0 && submitted && (
        <RequiredError
          headerText="Missing fields"
          text="Please provide a value for all fields highlighted below before search."
        />
      )}

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Button
            type="submit"
            className={styles.buttonViewStyle}
          >
            Search Products
          </Button>
          
        
        </Box>
      </Stack>
        <CreditScoreHelpTextModal
        open={creditScoreHelpTextOpen}
        handleClose={handleCloseCreditScoreHelpText}
        />
    </Box>
  );
};

export default QuickPricerForm;
